import React, { useState, useContext } from "react";
import Fade from "@material-ui/core/Fade";

import HeaderStroke from "../HeaderStroke";
import PerguntasFrequentesComponent from "./PerguntasFrequentes";
import MinhaCasaMinhaVidaComponent from "./MinhaCasaMinhaVida";
import ComoOndeFinanciarComponent from "./ComoOndeFinanciar";

import { ReactComponent as PerguntasICon } from "../../assets/novosicones/MeAjuda/Perguntas.svg";
import { ReactComponent as MinhaCasaICon } from "../../assets/novosicones/MeAjuda/MinhaCasa.svg";
import { ReactComponent as ComoOndeFinanciarIcon } from "../../assets/novosicones/MeAjuda/ComoOndeFinanciar.svg";

import { ContextoListaApartamentos } from "../ApartamentList/contextoImoveis";

import LinksUteis from "./LinksUteis";

import "./styles.scss";

const FinanciamentoComponent = () => {
  const [perguntas, setPerguntas] = useState(true);

  const [minhaCasa, setMinhaCasa] = useState(false);

  const [comoOndeFinanciar, setComoOndeFinanciar] = useState(false);

  const { tema } = useContext(ContextoListaApartamentos);

  function resetStates() {
    setPerguntas(false);
    setMinhaCasa(false);
    setComoOndeFinanciar(false);
  }

  return (
    <>
      <Fade in>
        <div>
          <HeaderStroke name={"Me Ajuda"} />
          <div className="centralized-column">
            <div className="menuMeuAjuda">
              <div
                style={
                  perguntas
                    ? { backgroundColor: tema.primaryColor }
                    : { backgroundColor: "#E8E8E8" }
                }
                className="centralized-column
                menuMeuAjuda__item
                "
                onClick={() => {
                  resetStates();
                  setPerguntas(true);
                }}
                id="btnPerguntasFrequentes"
              >
                <PerguntasICon
                  style={
                    perguntas ? { fill: "#fff" } : { fill: tema.primaryColor }
                  }
                />
                <span
                  style={
                    perguntas ? { color: "#fff" } : { color: tema.primaryColor }
                  }
                >
                  Perguntas Frequentes
                </span>
              </div>
              <div
                style={
                  minhaCasa
                    ? { backgroundColor: tema.primaryColor }
                    : { backgroundColor: "#E8E8E8" }
                }
                className="centralized-column
                menuMeuAjuda__item
                "
                onClick={() => {
                  resetStates();
                  setMinhaCasa(true);
                }}
                id="btnMinhaCasaMinhaVida"
              >
                <MinhaCasaICon
                  style={
                    minhaCasa ? { fill: "#fff" } : { fill: tema.primaryColor }
                  }
                />
                <span
                  style={
                    minhaCasa ? { color: "#fff" } : { color: tema.primaryColor }
                  }
                >
                  Minha casa, minha vida
                </span>
              </div>
              <div
                style={
                  comoOndeFinanciar
                    ? { backgroundColor: tema.primaryColor }
                    : { backgroundColor: "#E8E8E8" }
                }
                className="centralized-column
                menuMeuAjuda__item
                "
                onClick={() => {
                  resetStates();
                  setComoOndeFinanciar(true);
                }}
                id="btnComoOndeFinanciar"
              >
                <ComoOndeFinanciarIcon
                  style={
                    comoOndeFinanciar
                      ? { fill: "#fff" }
                      : { fill: tema.primaryColor }
                  }
                />
                <span
                  style={
                    comoOndeFinanciar
                      ? { color: "#fff" }
                      : { color: tema.primaryColor }
                  }
                >
                  Como e onde financiar?
                </span>
              </div>
            </div>
            <div className="centralized-space-between meuAjudaComponents">
              <div className="meuAjudaComponents__components">
                {perguntas && (
                  <div
                    className="centralized meuAjudaComponents__components__meAjudaItem"
                    style={{ justifyContent: "flex-start", height: "50px" }}
                  >
                    <PerguntasICon
                      style={{
                        width: "20px",
                        height: "20px",
                        fill: tema.primaryColor,
                      }}
                    />
                    <p
                      style={{
                        color: tema.primaryColor,
                      }}
                    >
                      Perguntas frequentes
                    </p>
                  </div>
                )}
                {minhaCasa && (
                  <div
                    className="centralized meuAjudaComponents__components__meAjudaItem"
                    style={{ justifyContent: "flex-start", height: "50px" }}
                  >
                    <MinhaCasaICon
                      style={{
                        width: "20px",
                        height: "20px",
                        fill: tema.primaryColor,
                      }}
                    />
                    <p
                      style={{
                        color: tema.primaryColor,
                      }}
                    >
                      Minha casa, minha vida
                    </p>
                  </div>
                )}
                {comoOndeFinanciar && (
                  <div
                    className="centralized meuAjudaComponents__components__meAjudaItem"
                    style={{ justifyContent: "flex-start", height: "50px" }}
                  >
                    <ComoOndeFinanciarIcon
                      style={{
                        width: "20px",
                        height: "20px",
                        fill: tema.primaryColor,
                      }}
                    />
                    <p
                      style={{
                        color: tema.primaryColor,
                      }}
                    >
                      Como e onde financiar?
                    </p>
                  </div>
                )}

                {perguntas && (
                  <PerguntasFrequentesComponent tema={tema.primaryColor} />
                )}
                {minhaCasa && (
                  <MinhaCasaMinhaVidaComponent tema={tema.primaryColor} />
                )}
                {comoOndeFinanciar && (
                  <ComoOndeFinanciarComponent tema={tema.primaryColor} />
                )}
              </div>

              <LinksUteis tema={tema} />
            </div>
          </div>
        </div>
      </Fade>
    </>
  );
};

export default FinanciamentoComponent;
